import { MijnRoute } from '../../mijn-navigatie.model';

export const FIXED_EXPENSES: MijnRoute = {
    path: 'vaste-lasten',
    navigationEvent: 'toFixedExpenses',
    regex: /^\/vaste-lasten$/,
    webcomponent: 'mijn-vaste-lasten-webcomponent'
};
